import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'simplebar-react/dist/simplebar.min.css';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from './theme';
// auth provider

import routes, { renderRoutes } from './routes';

const App = () => {
  const theme = createTheme();
  return (
    <React.Fragment>
        <ThemeProvider theme={theme}>
           <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>{renderRoutes(routes)}</BrowserRouter>
        </ThemeProvider>
    </React.Fragment>
  );
};

export default App;
